module.exports = __webpack_public_path__ + "static/media/logo-dark-en.2c2c8855.svg";